import { AppStatus } from '@/redux'
import { APIClient } from '@/services'
import { TypeGuards } from '@codeleap/common'
import { navigate as _navigate } from 'gatsby'
import { useAuthState } from '@/features/Auth/bridge/useAuthState'

export function authWall<T extends (...args: any[]) => any>(onAuth?: T, navigate = true) {
  return (...args: Parameters<T>) => {
    const profile = APIClient.Session.QueryKeys.me.getData()

    if (!profile) {
      if (navigate) return _navigate('/auth/signup/')

      return AppStatus.setModal('authWall')
    }

    if (TypeGuards.isFunction(onAuth)) {
      return onAuth?.(...args)
    }
  }
}

export const unknownOrgWall = (onAuth?: () => any) => {
  return () => {
    const profile = APIClient.Session.QueryKeys.me.getData()

    if (profile?.organization?.is_unknown) {
      AppStatus.setModal('unknownOrganisation')
      return
    }

    if (TypeGuards.isFunction(onAuth)) {
      onAuth?.()
    }
  }
}

export const useAuthWall = () => {
  const { isLoggedIn } = useAuthState()

  return !isLoggedIn
}
